import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "v1-mainContainer",
  class: "employee-section"
}
const _hoisted_2 = { class: "site-mid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_CreateTicketPopup = _resolveComponent("CreateTicketPopup")!
  const _component_ProjectTeamMembersPopup = _resolveComponent("ProjectTeamMembersPopup")!
  const _component_IssuePopup = _resolveComponent("IssuePopup")!
  const _component_DeleteFilePopup = _resolveComponent("DeleteFilePopup")!
  const _component_DownloadFilePopup = _resolveComponent("DownloadFilePopup")!
  const _component_DeleteConfirmPopup = _resolveComponent("DeleteConfirmPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Header),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ]),
      _createVNode(_component_Footer)
    ]),
    _createVNode(_component_CreateTicketPopup),
    _createVNode(_component_ProjectTeamMembersPopup),
    _createVNode(_component_IssuePopup),
    _createVNode(_component_DeleteFilePopup),
    _createVNode(_component_DownloadFilePopup),
    _createVNode(_component_DeleteConfirmPopup)
  ], 64))
}